// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2PCTN","errorLogs":"styles_errorLogs__3EjEg"};